import { render, staticRenderFns } from "./IndexProdItem.vue?vue&type=template&id=cc64944e&scoped=true&"
import script from "./IndexProdItem.vue?vue&type=script&lang=js&"
export * from "./IndexProdItem.vue?vue&type=script&lang=js&"
import style0 from "./IndexProdItem.vue?vue&type=style&index=0&id=cc64944e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc64944e",
  null
  
)

export default component.exports